export default "<div class=\"help-button-container\" (click)=\"openHelpVideo()\">\n  <i class=\"fa fa-info-circle\"></i>\n  Ajuda\n</div>"